import React from "react";
import {
  Input,
  Textarea,
  FormField,
  Checkbox,
  Label,
  Box,
  Text,
} from "@sproutsocial/racine";

const ComponentRequestForm = (fields, handleChange, dirty) => (
  <React.Fragment>
    <FormField
      label="Name"
      helperText="How might you name the component you’re requesting?"
      isInvalid={fields.name === "" && dirty}
      mb={0}
    >
      {(props) => (
        <Input
          value={fields.name}
          onChange={handleChange}
          name="name"
          placeholder="e.g. Toast"
          {...props}
        />
      )}
    </FormField>

    <FormField
      label="Description"
      helperText="Give us a brief overview of what this component would be used for, and why it would be valuable to you."
      isInvalid={fields.description === "" && dirty}
      mb={0}
    >
      {(props) => (
        <Textarea
          value={fields.description}
          onChange={handleChange}
          name="description"
          placeholder="e.g. We need a component for displaying notifications to users within our application"
          {...props}
        />
      )}
    </FormField>

    <FormField
      label="Examples (optional)"
      helperText="Are there examples of this component within our product or other products? Tell us about them here, and feel free to provide links."
      mb={0}
    >
      {(props) => (
        <Textarea
          value={fields.examples}
          onChange={handleChange}
          name="examples"
          placeholder="e.g. Dropbox Paper sends shows a toast after successfully copying a link to the user’s clipboard	"
          {...props}
        />
      )}
    </FormField>

    <FormField
      label="Reference (optional)"
      helperText="Have a Figma/Miro/Paper/Google document that captures the design of this component? Share the link here."
      mb={0}
    >
      {(props) => (
        <Input
          value={fields["visual-reference"]}
          onChange={handleChange}
          name="visual-reference"
          placeholder="Placeholder text..."
          {...props}
        />
      )}
    </FormField>

    <Box display="flex" alignItems="flex-start">
      <Checkbox
        checked={fields.volunteer}
        onChange={(e) => handleChange(e, !fields.volunteer)}
        name="volunteer"
        id="volunteer-checkbox"
        mr={350}
        mt="3px"
      />
      <Box>
        <Label htmlFor="volunteer-checkbox" mb={100}>
          Volunteer to help with this? (optional)
        </Label>

        <Text as="p" fontSize={200} color="text.subtext">
          If you or your team has the capacity to help us add this component to
          Seeds, let us know!
        </Text>
      </Box>
    </Box>
  </React.Fragment>
);

export default ComponentRequestForm;
